export default {
  __name: 'IfTheyCanDoItSoCanYou',
  setup(__props) {

return { __sfc: true, }
}

}